import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var HeartIcon = function () {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "#647386", children: _jsx("g", { "data-name": "vuesax/bold/heart-circle", children: _jsx("path", { "data-name": "Vector", d: "M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0zm.33 15a1.269 1.269 0 0 1-.67 0C8.1 14.47 4.6 12.24 4.6 8.46A3 3 0 0 1 10 6.65a3 3 0 0 1 5.4 1.81c0 3.78-3.5 6.01-5.07 6.54z", transform: "translate(2 2)", style: { fill: '#647386' } }) }) }));
};
export default memo(HeartIcon);
